// Card

export const BUYER_CAMPAIGN_BADGE = "Buyer Campaign";
export const HERO_TITLE = "Featured exposure, none of the legwork";
export const EXPIRY_PREFIX = "Don't miss out - Opt-in by ";
export const EXPIRY_SUFFIX = "!";
export const MAYBE_LATER_LABEL = "Maybe Later";
export const LEARN_MORE_LABEL = "Learn More";

// Modal

export const MODAL_TITLE = "Buyer Campaign Invitation";
export const BANNER_PREFIX = "This campaign comes directly from ";
export const FACILITATING_NOTE =
  "Hotel Trader facilitates the connection, participation is always your choice";
export const INVITATION_PREFIX = "Have invited you to take part in their ";
export const INVITATION_SUFFIX = " campaign.";
export const DOWNLOAD_HEADING_BOLD = "Download our campaign pack";
export const DOWNLOAD_HEADING_REST =
  " for more information, insights and participation requirements.";
export const REVIEW_PROMO_SETUP_LABEL = "Review Promo";

// Shared body sentence — "Join the {owner} {campaign}{BODY_SUFFIX}" + BODY_TAIL

export const BODY_PREFIX = "Join the ";
export const BODY_SUFFIX =
  " and get your property promoted across sale pages and push notifications in every market.";
export const BODY_TAIL =
  "Opt-in today to increase visibility and drive incremental bookings";

// Review Campaign drawer footer

export const CANCEL_LABEL = "Cancel";
export const LAUNCH_PROMO_LABEL = "Launch Promo";

// Misc

export const BUYER_FALLBACK_LABEL = "Buyer";
export const BUYER_AVATAR_FALLBACK_COLOR = "#3B82F6";

// Review Campaign Recommendation drawer — notice banner.

export const WARNING_BOLD =
  "This promotion can't be edited or disabled in Supplier Portal once launched.";
export const WARNING_REST =
  "To make changes or exit early, contact your account manager";

export const STACKING_HEADER_INLINE =
  "This promotion will stack with the following";
export const STACK_TOGGLE_SHOW = "show";
export const STACK_TOGGLE_HIDE = "hide";
